import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        name: Yup.string()
            .typeError(t('validation.valid.char'))
            .required(t('validation.enter.collection.name'))
            .matches(/^([a-zA-Z0-9()]+[\s]{0,1}){1,25}$/, {
                message: t('validation.valid.char'),
                excludeEmptyString: true,
            })
            .test('name', t('validation.existing.collection'), function (name) {
                return !this.parent.existingCollections?.some(
                    c => c?.toLowerCase() === name?.toLowerCase()
                )
            })
            .max(25),
    }
}
